module.exports = __webpack_public_path__ + "img/9.04ba2082.png";